import Tr from 'translations/Translations';
import getObjectValue from "libs/getObjectValue";

const createItem = (titleKey, descriptionKey, id, elements = [], type = 'deafult') => ({
    title: Tr(titleKey),
    description: Tr(descriptionKey),
    id,
    elements,
    type
})

const createElement = (titleKey, descriptionKey, id, type = 'deafult', checked) => ({
    title: Tr(titleKey),
    description: Tr(descriptionKey),
    id,
    type,
    checked,
})

const elements = {
    e1: createItem(
        'jedz_ex_a_t',
        'jedz_ex_a_d',
        'e1',
        [
            createElement('jedz_ex_a_1_t', 'jedz_ex_a_1_d', 'exclusionA1', "disabled", true),
            createElement('jedz_ex_a_2_t', 'jedz_ex_a_2_d', 'exclusionA2', "disabled", true
            ),
            createElement('jedz_ex_a_3_t', 'jedz_ex_a_3_d', 'exclusionA3', "disabled", true),
            createElement('jedz_ex_a_4_t', 'jedz_ex_a_4_d', 'exclusionA4', "disabled", true),
            createElement('jedz_ex_a_5_t', 'jedz_ex_a_5_d', 'exclusionA5', "disabled", true),
            createElement('jedz_ex_a_6_t', 'jedz_ex_a_6_d', 'exclusionA6', "disabled", true),
        ],
        "disabled"
    ),
    e2: createItem(
        'jedz_ex_b_t',
        'jedz_ex_b_d',
        'e2',
        [
            createElement('jedz_ex_b_1_t', 'jedz_ex_b_1_d', "exclusionB1", "disabled", true),
            createElement('jedz_ex_b_2_t', 'jedz_ex_b_2_d', "exclusionB2", "disabled", true),
        ],
        "disabled"),
    e3: createItem(
        'jedz_ex_c_t',
        'jedz_ex_c_d',
        'e3',
        [
            createElement('jedz_ex_c_1_t', 'jedz_ex_c_1_d', 'exclusionC1'),
            createElement('jedz_ex_c_2_t', 'jedz_ex_c_2_d', 'exclusionC2'),
            createElement('jedz_ex_c_3_t', 'jedz_ex_c_3_d', 'exclusionC3'),
            createElement('jedz_ex_c_4_t', 'jedz_ex_c_4_d', 'exclusionC4'),
            createElement('jedz_ex_c_5_t', 'jedz_ex_c_5_d', 'exclusionC5'),
            createElement('jedz_ex_c_6_t', 'jedz_ex_c_6_d', 'exclusionC6'),
            createElement('jedz_ex_c_7_t', 'jedz_ex_c_7_d', 'exclusionC7'),
            createElement('jedz_ex_c_8_t', 'jedz_ex_c_8_d', 'exclusionC8'),
            createElement('jedz_ex_c_9_t', 'jedz_ex_c_9_d', 'exclusionC9'),
            createElement('jedz_ex_c_10_t', 'jedz_ex_c_10_d', 'exclusionC10'),
            createElement('jedz_ex_c_11_t', 'jedz_ex_c_11_d', 'exclusionC11'),
            createElement('jedz_ex_c_12_t', 'jedz_ex_c_12_d', 'exclusionC12'),
            createElement('jedz_ex_c_13_t', 'jedz_ex_c_13_d', 'exclusionC13'),
            createElement('jedz_ex_c_14_t', 'jedz_ex_c_14_d', 'exclusionC14'),
            createElement('jedz_ex_c_15_t', 'jedz_ex_c_15_d', 'exclusionC15'),
        ]),
    e4: createItem(
        'jedz_ex_d_t',
        'jedz_ex_d_d',
        'e4',
        [
            createElement('jedz_ex_d_1_t', 'jedz_ex_d_1_d', 'exclusionD1'),
        ]
    )
}
export default Object.values(elements);

export const getInitValues = (sectionId, espdList, idPrefix) => {

    const item = elements[sectionId];

    const e = item.elements.reduce((prev, curr) => {
        return {
            ...prev,
            [curr.id]: getObjectValue(`${idPrefix}.${curr.id}`, espdList),
        }
    }, {})

    return e;
}


